import React, { useState } from 'react';
import { Collapse } from 'react-collapse';
import { TemplateContent } from "@ambiguous/templateContent";
import { useA11yContext } from '@assets/spa/context/a11y';
export default function Accordion({ items }) {
    const [openItem, setOpenItem] = useState(null);
    const [ref, setRef] = useState();
    function setOpen(id) {
        setOpenItem(id);
        if (!ref)
            return;
        setTimeout(() => {
            const active = ref.querySelector('.ltg-accordion-item.ltg-accordion-item--open');
            active && active.scrollIntoView({ behavior: 'smooth' });
        }, 600);
    }
    return (React.createElement("div", { ref: setRef, className: "ltg-accordion" }, items === null || items === void 0 ? void 0 : items.map((item) => React.createElement(Item, Object.assign({ key: item._id, setOpenItem: setOpen, openItem: openItem }, item)))));
}
function Item({ content, label, template, openItem, setOpenItem, _id, content_type, image }) {
    const [state] = useA11yContext();
    const has_image = (image === null || image === void 0 ? void 0 : image.url) && (state === null || state === void 0 ? void 0 : state.illustrations) === true;
    return (React.createElement("div", { className: `ltg-accordion-item${openItem == _id ? ' ltg-accordion-item--open' : ''}` },
        React.createElement("div", { className: `ltg-accordion-header${(image === null || image === void 0 ? void 0 : image.url) ? ' --has-image' : ''}`, onClick: () => { setOpenItem(_id == openItem ? null : _id); } },
            has_image && (React.createElement("div", { className: "ltg-accordion-img-wrap" },
                React.createElement("div", { className: "ltg-accordion-img-content" },
                    React.createElement("img", { className: "ltg-accordion-img", src: image.url, alt: image.alt || 'nuotrauka' })))),
            React.createElement("div", { className: "ltg-accordion-text-wrap" },
                React.createElement("div", { className: "ltg-accordion-label", dangerouslySetInnerHTML: { __html: label } }),
                React.createElement("div", { className: "ltg-accordion-chevron" },
                    React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round", className: "feather feather-chevron-down" },
                        React.createElement("polyline", { points: "6 9 12 15 18 9" }))))),
        React.createElement(Collapse, { isOpened: openItem == _id }, (content_type === 'template' && !!(template === null || template === void 0 ? void 0 : template.id)) ? (React.createElement(DynamicContent, { template: template })) : (React.createElement(StaticContent, { content: content })))));
}
function StaticContent({ content }) {
    return (React.createElement("div", { className: "ltg-accordion-content-wrap" },
        React.createElement("div", { className: "ltg-accordion-content", dangerouslySetInnerHTML: { __html: content } })));
}
function DynamicContent({ template }) {
    return (React.createElement("div", { className: "ltg-accordion-content-wrap" },
        React.createElement("div", { className: "ltg-accordion-content" }, TemplateContent(template === null || template === void 0 ? void 0 : template.id))));
    // const [innerContent, setInnerContent] = useState('');
    // const {data,loading} = useQuery(gqlTemplate,{
    // 	variables:{
    // 		id:template.id,
    // 	},
    // 	client
    // });
    // useEffect(()=>{
    // 	const templateMarkup = data?.elementorTemplate?.content;
    // 	if(!templateMarkup) return;
    // 	let itemCssLinks = '';
    // 	const extraCss:{href:string,id:string}[] = data?.elementorTemplate?.css;
    // 	if(extraCss){
    // 		itemCssLinks = extraCss.reduce((agr,item)=>`${agr}<link rel="stylesheet" href="${item.href}"></link>`,'')
    // 	}
    // 	setInnerContent(itemCssLinks + templateMarkup);
    // },[data])
    // return(<div className="ltg-accordion-content-wrap">
    // 	<div className="ltg-accordion-content" dangerouslySetInnerHTML={{__html:innerContent}}></div>
    // </div>)
}
